import {} from "@/lib/common/common.js";
import Vue from "vue";
import router from "./router";

import App from "./App.vue";
import store from "./store";

// plugins
import "@/plugins";

// scss
import "@/assets/roomType/conf/css/_roomSettingRenew.scss";

// mixins
import "@/mixins";

import { i18n } from "@/locales/i18n";

new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
